import React from 'react';

import { PublicPage } from 'api/website';
import { Box } from 'components/Box';
import { PrimaryButtonLink } from 'components/Button';
import { Icon } from 'components/Icon';

type Props = {
  content: PublicPage;
};

export function StaffTools({ content }: Props) {
  return (
    <Box
      p="0 !important"
      component={PrimaryButtonLink}
      href={
        content.subsite
          ? `/cms/subsite/${
              content.subsite.id
            }/${content.type.toLowerCase()}s/${content.id}/edit`
          : undefined
      }
      data-qa-id="edit-button"
      aria-label={getText('Edit')}
      borderRadius="50% !important"
      boxShadow="0 2px 3px rgba(0,0,0,0.25)"
    >
      <Box
        width={40}
        height={40}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Icon initialColorName="white" name="pencil" size={24} />
      </Box>
    </Box>
  );
}
